// import React, { useEffect, useState } from 'react';
// import { Avatar, Box, Typography, Stack, Button } from '@mui/material';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import { Group } from '@mui/icons-material';
// import { useDispatch } from 'react-redux';
// import actions from '../../../ReduxStore/actions';
// import { useNavigate } from 'react-router-dom';

// const userData = {
//   pages: [
//     { name: 'Cynthia Cox', lastSeen: '11 min', online: false },
//     { name: 'Danny Quinn', online: true },
//   ],
//   connections: [
//     { name: 'Morgan', lastSeen: '11 min', online: false },
//     { name: 'Stanley Burton', online: true },
//     { name: 'Allen Anderson', online: true },
//     { name: 'Lucas West', lastSeen: '11 min', online: false },
//     { name: 'Danny Moore', lastSeen: '9 min', online: false },
//     { name: 'Jason Gutierrez', online: true },
//   ],
//   groups: [
//     { name: 'Morgan', lastSeen: '11 min', online: false },
//     { name: 'Stanley Burton', online: true },
//     { name: 'Allen Anderson', online: true },
//     { name: 'Lucas West', lastSeen: '11 min', online: false },
//     { name: 'Danny Moore', lastSeen: '9 min', online: false },
//     { name: 'Jason Gutierrez', online: true },
//   ]
// };

// const StatusIndicator = ({ online, lastSeen }) => (
//   <Box display="flex" alignItems="center">
//     {online ? (
//       <FiberManualRecordIcon fontSize="small" sx={{ color: 'green' }} />
//     ) : (
//       <Typography variant="caption" color="text.secondary">
//         {lastSeen}
//       </Typography>
//     )}
//   </Box>
// );

// const UserRow = ({ user, name, online, lastSeen, handleConnectButton }) => (
//   <Box
//     px={1.5} py={1}
//     mt={2}
//     onClick={() => {
//       handleConnectButton(user?.user_id)

//     }}
//     sx={{ cursor: "pointer", boxShadow: 1 }}

//   >
//     <Box display="flex" alignItems="center" gap={1.5}>
//       <Avatar sx={{ width: 32, height: 32 }} src={user?.profileImage} />
//       <Typography variant="subtitle1" sx={{ color: "#514c4c", fontWeight: "600" }}>{user?.name}</Typography>
//     </Box>
//     {/* <StatusIndicator online={online} lastSeen={lastSeen} /> */}
//   </Box>
// );



// const SidebarUserList = () => {
//   const [connectionData, setConnectionData] = useState([])
//   console.log(connectionData, "connectionData")
//   const [showAll, setShowAll] = useState(false);

//   const visibleConnections = showAll ? connectionData : connectionData?.slice(0, 8);


//   const dispatch = useDispatch()

//   const sessionUserId = sessionStorage.getItem("userId")
//   useEffect(() => {
//     console.log(sessionUserId, "sessionUserId1111111")


//     const fetchData = async () => {
//       const data1 = {
//         data: {},
//         method: "get",
//         apiName: `getUserConnections/${sessionUserId}`,
//       };
//       const response = await dispatch(actions.GETUSERCONNECTIONS(data1));

//       console.log(response, "responseresponse")

//       if (response?.payload?.message === "Connections fetched.") {
//         console.log("hiiiiiiiiiiiiiiii")

//         const responseData = response?.payload?.data?.map((data) => ({
//           user_id: data?.user_id,
//           name: `${data?.first_name} ${data?.last_name}`,
//           profileImage: data?.profileImage,





//         }))
//         setConnectionData(responseData)

//       }
//     }
//     fetchData()


//   }, [])
//   // const dispatch = useDispatch()
//   const navigate = useNavigate()

//   const handleConnectButton = async (user_id) => {
//     console.log(user_id, "userrrrrrrrr")
//     navigate(`/user/viewprofiledetails/${user_id}`)
//   }

//   return (
//     <Box p={2} sx={{ minHeight: "80vh" }}>
//       {/* <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
//         Your Pages
//       </Typography>
//       <Stack spacing={1}>
//         {userData.pages.map((user, i) => (
//           <UserRow key={i} {...user} />
//         ))}
//       </Stack> */}

//       <Typography variant="subtitle1" sx={{ fontSize: "18px", color: "black", fontWeight: "600", mb: 2 }}>
//         My Connections
//       </Typography>
//       <Box spacing={1}>
//         {/* {connectionData?.length < 8}
//         {connectionData?.map((user, i) => (
//           <UserRow key={i} user={user} handleConnectButton={handleConnectButton} />
//         ))} */}
//         {visibleConnections?.map((user, i) => (
//           <UserRow key={i} user={user} handleConnectButton={handleConnectButton} />
//         ))}

//         {!showAll && connectionData?.length > 8 && (
//           <Box sx={{ display: "flex", justifyContent: "center" }}>
//             <Button onClick={() => {
//               navigate("/user/myconnections")
//             }} sx={{ mt: 2, textTransform: "none" }}>
//               See More
//             </Button>
//           </Box>
//         )}

//       </Box>

//       {/* <Typography variant="subtitle1" fontWeight="bold" mt={3} gutterBottom>
//         My Groups
//       </Typography>
//       <Stack spacing={1}>
//         {userData.groups.map((user, i) => (
//           <UserRow key={i} {...user} />
//         ))}
//       </Stack> */}
//     </Box>
//   );
// };

// export default SidebarUserList;


import React, { useEffect, useState } from 'react';
import { Avatar, Box, Typography, Stack, Button, Divider, Paper } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Group } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { useNavigate } from 'react-router-dom';

const userData = {
  pages: [
    { name: 'Cynthia Cox', lastSeen: '11 min', online: false },
    { name: 'Danny Quinn', online: true },
  ],
  connections: [
    { name: 'Morgan', lastSeen: '11 min', online: false },
    { name: 'Stanley Burton', online: true },
    { name: 'Allen Anderson', online: true },
    { name: 'Lucas West', lastSeen: '11 min', online: false },
    { name: 'Danny Moore', lastSeen: '9 min', online: false },
    { name: 'Jason Gutierrez', online: true },
  ],
  groups: [
    { name: 'Morgan', lastSeen: '11 min', online: false },
    { name: 'Stanley Burton', online: true },
    { name: 'Allen Anderson', online: true },
    { name: 'Lucas West', lastSeen: '11 min', online: false },
    { name: 'Danny Moore', lastSeen: '9 min', online: false },
    { name: 'Jason Gutierrez', online: true },
  ]
};

const StatusIndicator = ({ online, lastSeen }) => (
  <Box display="flex" alignItems="center">
    {online ? (
      <FiberManualRecordIcon fontSize="small" sx={{ color: 'green' }} />
    ) : (
      <Typography variant="caption" color="text.secondary">
        {lastSeen}
      </Typography>
    )}
  </Box>
);

const UserRow = ({ user, name, online, lastSeen, handleConnectButton }) => (
  <Box
    px={1.5} py={1}
    mt={2}
    onClick={() => {
      handleConnectButton(user?.user_id)

    }}
    sx={{ cursor: "pointer", boxShadow: 1 }}

  >
    <Box display="flex" alignItems="center" gap={1.5}>
      <Avatar sx={{ width: 32, height: 32 }} src={user?.profileImage} />
      <Typography variant="subtitle1" sx={{ color: "#514c4c", fontWeight: "600" }}>{user?.name}</Typography>
    </Box>
    {/* <StatusIndicator online={online} lastSeen={lastSeen} /> */}
  </Box>
);



const SidebarUserList = () => {
  const [connectionData, setConnectionData] = useState([])
  console.log(connectionData, "connectionData")
  const [showAll, setShowAll] = useState(false);

  const visibleConnections = showAll ? connectionData : connectionData?.slice(0, 8);


  const dispatch = useDispatch()

  const sessionUserId = sessionStorage.getItem("userId")
  useEffect(() => {
    console.log(sessionUserId, "sessionUserId1111111")


    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getUserConnections/${sessionUserId}`,
      };
      const response = await dispatch(actions.GETUSERCONNECTIONS(data1));

      console.log(response, "responseresponse")

      if (response?.payload?.message === "Connections fetched.") {
        console.log("hiiiiiiiiiiiiiiii")

        const responseData = response?.payload?.data?.map((data) => ({
          user_id: data?.user_id,
          name: `${data?.first_name} ${data?.last_name}`,
          profileImage: data?.profileImage,





        }))
        setConnectionData(responseData)

      }
    }
    fetchData()


  }, [])
  // const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleConnectButton = async (user_id) => {
    console.log(user_id, "userrrrrrrrr")
    navigate(`/user/viewprofiledetails/${user_id}`)
  }

  // MentorRequirementGetAll

  const { MentorRequirementGetAll } = useSelector(state => state?.MentorRequirementGetAll);

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllMentorRequirements`,
      };
      await dispatch(actions.MENTORREQUIREMENTGETALL(data1));
    };
    fetchData();
  }, [dispatch, sessionUserId]);


  return (
    <Box p={2} sx={{ minHeight: "50vh", mt: 4, background: "white" }}>
      {/* <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Your Pages
      </Typography>
      <Stack spacing={1}>
        {userData.pages.map((user, i) => (
          <UserRow key={i} {...user} />
        ))}
      </Stack> */}

      {/* <Typography variant="subtitle1" sx={{ fontSize: "18px", color: "black", fontWeight: "600", mb: 2 }}>
        My Connections
      </Typography>
      <Box spacing={1}>
       
        {visibleConnections?.map((user, i) => (
          <UserRow key={i} user={user} handleConnectButton={handleConnectButton} />
        ))}

        {!showAll && connectionData?.length > 8 && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button onClick={() => {
              navigate("/user/myconnections")
            }} sx={{ mt: 2, textTransform: "none" }}>
              See More
            </Button>
          </Box>
        )} 

      </Box>*/}

      {/* <Typography variant="subtitle1" fontWeight="bold" mt={3} gutterBottom>
        My Groups
      </Typography>
      <Stack spacing={1}>
        {userData.groups.map((user, i) => (
          <UserRow key={i} {...user} />
        ))}
      </Stack> */}
      <Typography variant="subtitle1" sx={{ fontSize: "18px", color: "black", fontWeight: "600" }}>
        Mentor Requirements
      </Typography>
      <Divider sx={{ mt: 1 }} />
      {MentorRequirementGetAll?.data?.length > 0 ? (
        <>

          {MentorRequirementGetAll?.data?.map((item) => (
            <Paper key={item.mentor_id} elevation={1} sx={{ mb: 2, p: 2 }}>
              <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600 }}>
                {item.mentor_type} - {item.expertise}
              </Typography>

              <Typography sx={{ fontSize: "14px", color: "gray", mb: 1 }}>
                {item.campus_requirement} &nbsp;|&nbsp;
                Vacancies: {item.vacancies}
              </Typography>

              <Typography sx={{ fontSize: "14px", color: "black" }}>
                From: {item.from_date} &nbsp;&nbsp; To: {item.to_date}
              </Typography>

              <Typography sx={{ mt: 1.5 }}>
                {item.requirements}
              </Typography>

              <Typography sx={{ fontSize: "12px", color: "gray", mt: 1 }}>
                Posted on: {new Date(item.createdAt).toLocaleDateString()}
              </Typography>
            </Paper>
          ))}
        </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '40vh', // or adjust as needed
              width: '100%',
            }}
          >
            <Typography variant='subtitle1'>
              No mentor requirement post yet!
            </Typography>
          </Box>
        )}

    </Box>
  );
};

export default SidebarUserList;
